import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';

export default function AlertDialog({deletar}) {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const confirme = () => {
    deletar();
    handleClose();
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton color="secondary" onClick={handleClickOpen}>
        <Clear/>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deseja realmente cancelar esse agendamento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirme} color="primary" variant="contained">
            Sim
          </Button>
          <Button onClick={handleClose} color="secondary" variant="contained" >
            Não
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}